import React, { useState } from "react";
import { Eye, UploadCloud } from "lucide-react";

// ---- SIMULACIÓN DE DATOS DEL BACK ----
const resolucionesApi = [
  {
    id: 1,
    prefijo: "SETT",
    tipo: "Factura de Venta",
    numero: "187600001",
    rangoInicial: 1,
    rangoFinal: 2000,
    fechaInicio: "2024-01-01",
    fechaFin: "2025-06-10",
  },
  {
    id: 2,
    prefijo: "SEDS",
    tipo: "Documento Soporte",
    numero: "188400021",
    rangoInicial: 1,
    rangoFinal: 500,
    fechaInicio: "2024-02-15",
    fechaFin: "2025-06-30",
  },
  {
    id: 3,
    prefijo: "SETP",
    tipo: "Factura de Venta",
    numero: "187600019",
    rangoInicial: 500,
    rangoFinal: 3000,
    fechaInicio: "2024-01-10",
    fechaFin: "2026-08-15",
  },
];

// ---- UTILIDADES PARA LA TABLA ----
const calcularDiasParaVencer = (fechaFin) => {
  const hoy = new Date();
  const fin = new Date(fechaFin + "T23:59:59");
  return Math.ceil((fin - hoy) / (1000 * 60 * 60 * 24));
};
const getEstado = (dias) => {
  if (dias < 0) return { texto: "Vencido", color: "bg-red-100 text-red-700" };
  if (dias <= 30) return { texto: "Por vencer", color: "bg-yellow-100 text-yellow-800" };
  return { texto: "Activo", color: "bg-green-100 text-green-800" };
};
const getBadgeColor = (prefijo) => {
  if (prefijo === "SETT") return "bg-blue-100 text-blue-700";
  if (prefijo === "SEDS") return "bg-violet-100 text-violet-700";
  if (prefijo === "SETP") return "bg-cyan-100 text-cyan-700";
  return "bg-gray-100 text-gray-700";
};

export default function AutorizacionesDianFirmaPage() {
  // ----------- MODAL DE FIRMA -----------
  const [modalFirma, setModalFirma] = useState(false);
  const [certFile, setCertFile] = useState(null);
  const [certFileName, setCertFileName] = useState("");
  const [certPassword, setCertPassword] = useState("");
  const [subiendo, setSubiendo] = useState(false);

  // ------- HANDLERS MODAL FIRMA --------
  const handleCertChange = (e) => {
    const file = e.target.files[0];
    if (file && file.name.toLowerCase().endsWith(".pfx")) {
      setCertFile(file);
      setCertFileName(file.name);
    } else {
      setCertFile(null);
      setCertFileName("");
      alert("Solo se permiten archivos .pfx para la firma digital.");
    }
  };

  const handleFirmaSubmit = async (e) => {
    e.preventDefault();
    setSubiendo(true);
    try {
      const formData = new FormData();
      formData.append("certificado", certFile);
      formData.append("contrasena", certPassword);

      // Cambia la URL por tu endpoint real:
      const resp = await fetch("/api/firma/cargar-certificado", {
        method: "POST",
        body: formData,
      });

      if (!resp.ok) throw new Error("Error al cargar el certificado");
      setModalFirma(false);
      setCertFile(null);
      setCertFileName("");
      setCertPassword("");
      alert("Certificado de firma digital cargado correctamente (simulado)");
    } catch (err) {
      alert("Hubo un error cargando el certificado: " + err.message);
    } finally {
      setSubiendo(false);
    }
  };

  // --------- RESOLUCIONES ORDENADAS Y FILTRADAS ---------
  const resolucionesOrdenadas = resolucionesApi
    .map((r) => {
      const diasParaVencer = calcularDiasParaVencer(r.fechaFin);
      return {
        ...r,
        diasParaVencer,
        ...getEstado(diasParaVencer),
      };
    })
    .filter((r) => r.diasParaVencer >= 0) // Solo vigentes
    .sort((a, b) => a.diasParaVencer - b.diasParaVencer);

  return (
    <div className="bg-white w-full max-w-5xl mx-auto rounded-2xl shadow-xl px-6 py-8 border">
      <h3 className="text-2xl font-bold text-[#003865] mb-6">
        Autorizaciones DIAN y Firma Digital
      </h3>

      {/* ----------- TABLA DE NUMERACIONES ----------- */}
      <div className="mb-10">
        <h4 className="text-lg font-semibold text-[#003865] mb-3 border-b pb-2">
          Numeraciones Vigentes DIAN
        </h4>
        <div className="overflow-x-auto max-h-[370px]">
          <table className="min-w-full divide-y divide-gray-100 text-xs">
            <thead>
              <tr className="bg-gray-100">
                <th className="px-2 py-1 text-left font-semibold w-[9%]">Prefijo</th>
                <th className="px-2 py-1 text-left font-semibold w-[14%]">Tipo</th>
                <th className="px-2 py-1 text-left font-semibold w-[14%]">No. Autorización</th>
                <th className="px-2 py-1 text-center font-semibold w-[13%]">Rango</th>
                <th className="px-2 py-1 text-center font-semibold w-[11%]">Inicio</th>
                <th className="px-2 py-1 text-center font-semibold w-[11%]">Fin</th>
                <th className="px-2 py-1 text-center font-semibold w-[11%]">Días p/vencer</th>
                <th className="px-2 py-1 text-center font-semibold w-[10%]">Estado</th>
                <th className="px-2 py-1 text-center font-semibold w-[6%]"></th>
              </tr>
            </thead>
            <tbody>
              {resolucionesOrdenadas.map((r) => (
                <tr key={r.id} className="border-b hover:bg-blue-50">
                  <td className="px-2 py-1">
                    <span className={`px-2 py-0.5 rounded-full font-semibold ${getBadgeColor(r.prefijo)}`}>
                      {r.prefijo}
                    </span>
                  </td>
                  <td className="px-2 py-1">{r.tipo}</td>
                  <td className="px-2 py-1">{r.numero}</td>
                  <td className="px-2 py-1 text-center">{r.rangoInicial} - {r.rangoFinal}</td>
                  <td className="px-2 py-1 text-center">{r.fechaInicio}</td>
                  <td className="px-2 py-1 text-center">{r.fechaFin}</td>
                  <td className="px-2 py-1 text-center font-bold">{r.diasParaVencer}</td>
                  <td className="px-2 py-1 text-center">
                    <span className={`px-2 py-0.5 rounded-full font-semibold ${r.color}`}>
                      {r.texto}
                    </span>
                  </td>
                  <td className="px-2 py-1 flex justify-center">
                    <button
                      className="hover:bg-blue-100 p-1 rounded transition-transform hover:scale-110"
                      title="Ver detalle"
                      onClick={() => alert("Detalle de resolución (demo)")}
                    >
                      <Eye className="w-4 h-4 text-[#003865]" />
                    </button>
                  </td>
                </tr>
              ))}
              {resolucionesOrdenadas.length === 0 && (
                <tr>
                  <td colSpan={9} className="py-3 text-center text-gray-400 font-medium">
                    No hay rnumeraciones vigentes encontradas.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* ----------- SECCIÓN FIRMA DIGITAL ----------- */}
      <div>
        <h4 className="text-lg font-semibold text-[#003865] mb-3 border-b pb-2">
          Estado de la Firma Digital
        </h4>
        <div className="flex flex-col md:flex-row items-center md:items-start gap-6 py-3">
          <div className="flex-1">
            <div className="mb-2">
              <span className="font-semibold text-gray-700">Estado: </span>
              <span className="bg-green-100 text-green-800 px-2 py-0.5 rounded-full font-semibold text-xs">
                Vigente
              </span>
            </div>
            <div className="mb-2">
              <span className="font-semibold text-gray-700">Expira: </span>
              <span className="text-[#003865] font-semibold">2025-04-20</span>
            </div>
            <div>
              <span className="font-semibold text-gray-700">Certificado: </span>
              <span className="text-gray-500">certificado_2025.pfx</span>
            </div>
          </div>
          <div>
            <button
              className="bg-[#003865] text-white px-5 py-2 rounded-lg shadow font-bold text-xs hover:bg-blue-700 transition flex items-center gap-2"
              onClick={() => setModalFirma(true)}
            >
              <UploadCloud className="w-4 h-4" />
              Renovar / Cargar Firma Digital
            </button>
          </div>
        </div>
      </div>

      {/* ----------- MODAL FIRMA DIGITAL ----------- */}
      {modalFirma && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-lg w-full max-w-sm mx-2 relative flex flex-col">
            <button
              onClick={() => setModalFirma(false)}
              className="absolute top-2 right-3 text-gray-400 hover:text-gray-700 text-2xl"
            >
              ×
            </button>
            <div className="overflow-y-auto p-6">
              <h4 className="text-lg font-bold text-[#003865] mb-3">
                Cargar/Renovar Certificado de Firma Digital
              </h4>
              <form className="space-y-5" onSubmit={handleFirmaSubmit}>
                <div>
                  <label className="block font-semibold mb-1 text-gray-800">
                    Certificado (.pfx) <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="file"
                    accept=".pfx"
                    onChange={handleCertChange}
                    className="border border-gray-200 rounded-lg p-2 w-full bg-white text-xs"
                    required
                  />
                  {certFileName && (
                    <span className="block text-xs mt-1 text-green-700">
                      {certFileName}
                    </span>
                  )}
                </div>
                <div>
                  <label className="block font-semibold mb-1 text-gray-800">
                    Contraseña de la firma <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="password"
                    value={certPassword}
                    onChange={e => setCertPassword(e.target.value)}
                    className="border border-gray-200 rounded-lg h-10 p-2 w-full"
                    required
                  />
                </div>
                <div className="flex justify-end pt-2">
                  <button
                    type="submit"
                    disabled={!certFile || !certPassword || subiendo}
                    className={`bg-[#003865] text-white px-8 py-2 rounded-xl shadow font-bold text-base transition ${
                      (!certFile || !certPassword || subiendo)
                        ? "opacity-50 cursor-not-allowed"
                        : "hover:bg-blue-700"
                    }`}
                  >
                    {subiendo ? "Cargando..." : "Guardar certificado"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}
